module.exports = __webpack_public_path__ + "img/nl.10d31cc2.svg";